import { createReducer, on } from '@ngrx/store'

import { DeepAgentActions } from './deep-agent.actions'
import {
  onAddInitialMessage,
  onClearMessages,
  onGetAgentResponseFailure,
  onGetAgentResponseStream,
  onGetAgentResponseStreamCompleted,
  onRedoMessage,
  onSaveDeepAgent,
  onSaveDeepAgentFailure,
  onSaveDeepAgentSuccess,
  onSendFeedback,
  onSetCurrentAgent,
  onUserSendMessage,
} from './deep-agent.handler'
import { initialState } from './deep-agent.state'

export const deepAgentReducer = createReducer(
  initialState,
  on(DeepAgentActions.getDeepAgentResponseStream, onGetAgentResponseStream),
  on(DeepAgentActions.userSendMessage, (state, action) => ({
    ...onUserSendMessage(state, action),
    buildMode: 'agent' as const,
  })),
  on(DeepAgentActions.userSendBuildWorkflowMessage, (state, action) => ({
    ...onUserSendMessage(state, action),
    buildMode: 'workflow' as const,
  })),
  on(DeepAgentActions.getDeepAgentResponseFailure, onGetAgentResponseFailure),
  on(DeepAgentActions.getDeepAgentResponseStreamCompleted, onGetAgentResponseStreamCompleted),
  on(DeepAgentActions.sendFeedback, onSendFeedback),
  on(DeepAgentActions.redoMessage, onRedoMessage),
  on(DeepAgentActions.clearMessages, onClearMessages),
  on(DeepAgentActions.addInitialMessage, onAddInitialMessage),
  on(DeepAgentActions.setModels, (state, { models }) => ({
    ...state,
    models,
  })),
  on(DeepAgentActions.saveDeepAgent, onSaveDeepAgent),
  on(DeepAgentActions.saveDeepAgentSuccess, onSaveDeepAgentSuccess),
  on(DeepAgentActions.saveDeepAgentFailure, onSaveDeepAgentFailure),
  on(DeepAgentActions.setCurrentAgent, onSetCurrentAgent)
)
